module.exports = __webpack_public_path__ + "img/c0d4d9a.png";